import { lazy, Suspense } from 'react';
import { createFileRoute } from '@tanstack/react-router';
import { PageLoader } from '@customerio/pluma-components/react';
import { withRumPageRendered } from '@/services/rum/use-page-rendered';

const NewsletterSetupRecipientsStep = lazy(
  () => import('@/pages/workspaces/broadcasts/newsletter/setup/recipients/index.page'),
);

function NewsletterSetupRecipientsRoute() {
  return (
    <Suspense fallback={<PageLoader label="Loading…" />}>
      <NewsletterSetupRecipientsStep />
    </Suspense>
  );
}

export const Route = createFileRoute(
  '/_authenticated/workspaces/$workspaceId/broadcasts_/newsletter/$newsletterId/setup/recipients',
)({ component: withRumPageRendered(NewsletterSetupRecipientsRoute) });
